import React, { Fragment } from 'react';
import { asyncConnect } from 'react-async-client';
import { Alert, Button, Spin } from 'antd';
import Translate from 'react-translate-component';

import { login } from 'actions/userActions';

let autologin = true;
const handleLogin = () => autologin = false;
const loginParams = { sso: true };

export default asyncConnect(() => ({
    login: login
        .withParams(loginParams)
        .withPayload(() => loginParams)
        .withSuccessHandler(handleLogin)
        .withErrorHandler(handleLogin)
        .withOptions({ dispatchOnMount: autologin }),
}), ({ sessionOver }) => ({ sessionOver }))(
    ({ sessionOver, login: { meta, refresh } }) => (
        <Fragment>
            { sessionOver && (
                <Alert
                    className="guest-layout-error"
                    type="error"
                    message={<Translate content="error.6" />}
                />
            )}
            { meta.error && (
                <Alert
                    className='guest-layout-error'
                    type='error'
                    message={<Translate content="errors.sso" unsafe />}
                />
            )}

            { meta.pending ? (
                <Spin />
            ) : (
                <Button type="primary" size="large" className="login-form-button" onClick={() => refresh()}>
                    <Translate content='guest.toLoginSSO' />
                </Button>
            )}
        </Fragment>
    )
);
